 
import { sCAuth } from "schmucklicloud_auth";
import { sCStorage } from "schmucklicloud_storage";
import { sCMessaging } from "schmucklicloud_messaging";

//Note: Also change these value in public/oauth_complete.html since it is a static website
const APP_ID = "09486073ac97f6b9f49d9e0d3996a77948b9bdb6";
const APP_SECRET = "11ae6058a7c7a8920c818702951b23b6928673d6611c4d49cf92714b5914ad28";

var auth = new sCAuth(APP_ID, APP_SECRET);
var storage = new sCStorage(APP_ID, APP_SECRET);
var s_messaging = new sCMessaging(APP_ID, APP_SECRET);

storage.setBucket(21);

var session_token = window.localStorage.getItem("session_token");

storage.setAuthToken(session_token);
s_messaging.setAuthToken(session_token);

export { auth, storage, s_messaging };